import { report } from "report"
import { IGameState } from "State/Game/IGameState"
import { sendEvent, track } from "../Track"
import { UserEventName } from "../TrackingEvent"

export const trackUserUnification = (state: IGameState, formerUserID: string, newUserID: string) => {
    try {
        track("userID", newUserID);
        track("newUserID", newUserID);
        track("formerUserID", formerUserID);
        // Send event for new user / save data
        sendEvent(UserEventName.userUnification, state);
    }
    catch (error) {
        report("Failed to track user unification event", {
            error,
            once: true,
            sampleRate: 0.5,
            fingerprint: "trackUserUnification"
        })
    }
}
